var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "45px",
    viewBox: "0 0 34 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Restaurants-page-Copy-36",
    transform: "translate(-1593.000000, -283.000000)",
    fill: "#282C3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1611.5,321.817167 L1611.5,328 L1608.5,328 L1608.5,321.817167 C1604.34653,318.214421 1593,307.670418 1593,300 C1593,290.611159 1600.61116,283 1610,283 C1619.38884,283 1627,290.611159 1627,300 C1627,307.670418 1615.65347,318.214421 1611.5,321.817167 Z M1610,305 C1612.48528,305 1614.5,302.985281 1614.5,300.5 C1614.5,298.014719 1612.48528,296 1610,296 C1607.51472,296 1605.5,298.014719 1605.5,300.5 C1605.5,302.985281 1607.51472,305 1610,305 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.aa0e9652e0ee16deab254945c0626e13.svg";
export { ForwardRef as ReactComponent };